import IComponent from "components/commons/IComponent";
import FilterList from "components/commons/FilterList";
import "./FilterPanel.scoped.css";
import React, { Fragment } from "react";
import { Radio, RadioGroup, FormControlLabel, Button } from "@material-ui/core";
let filter_list = [
  {
    title: "showOnList",
    titleText: "Show On List",
    type: "Radio",
    values: ["showAll", "showSelectedOnly"],
    valueText: ["Show All", "Show Selected Only"],
  },
];

const GENERAL_RESULT = "General Result";
class FilterPanel extends IComponent {
  constructor(props) {
    super(props);

    let { filter_list, filterOptions } = props;

    let tmpFilterOptions = { ...filterOptions };

    if (
      typeof filterOptions.locationList === "undefined" ||
      typeof filterOptions.slopeNoList === "undefined"
    ) {
      let filterList = this.processFilterList(props, false);
      tmpFilterOptions = { ...tmpFilterOptions, ...filterList };
    } else {
      tmpFilterOptions.locationList = JSON.parse(
        JSON.stringify(tmpFilterOptions.locationList)
      );
      tmpFilterOptions.slopeNoList = JSON.parse(
        JSON.stringify(tmpFilterOptions.slopeNoList)
      );
    }

    // onListOption, activeList, locationList, slopeNoList
    this.state = tmpFilterOptions;
  }
  componentDidMount() {}
  componentWillUnmount() {}

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.currentCategory !== this.props.currentCategory) {
      let state = this.processFilterList(undefined);
      state = { ...this.props.filterOptions, ...state };
      this.setState(state);
    }
  }

  processFilterList(props, setToState) {
    props = props || this.props;

    let locationList = undefined;
    let slopeNoList = undefined;

    let array =
      props.currentCategory === GENERAL_RESULT
        ? Object.values(props.resultList).flat()
        : props.resultList[props.currentCategory];
    locationList = Array.from(new Set(array.map((i) => i.metaData?.location)));
    locationList = locationList
      .filter((i) => !!i)
      .map((i) => ({ optionName: i, checked: true }));
    slopeNoList = Array.from(
      new Set(
        array
          .map((i) => i.metaData?.slopeNo && Object.keys(i.metaData?.slopeNo))
          .flat()
      )
    );
    slopeNoList = slopeNoList
      .filter((i) => !!i)
      .map((i) => ({ optionName: i, checked: true }));

    this.sortOptions(slopeNoList);
    this.sortOptions(locationList);

    locationList.push({ optionName: "Others", checked: true });
    slopeNoList.push({ optionName: "Others", checked: true });
    let state = {
      locationList,
      slopeNoList,
    };

    if (setToState) this.setState(state);
    else return state;
  }

  sortOptions(optionList) {
    let optionNameArr = optionList.map((val) => val.optionName);

    optionNameArr.sort((a, b) => {
      let slopeA = parseInt(a.match(/(\d{1,2}).*?/)?.[0]);
      let slopeB = parseInt(b.match(/(\d{1,2}).*?/)?.[0]);

      if (isNaN(slopeA) || isNaN(slopeB)) return a < b ? -1 : a == b ? 0 : 1;

      let cmpResult = slopeA - slopeB;
      if (cmpResult != 0) return cmpResult;
      else return slopeA < slopeB ? -1 : a == b ? 0 : 1;
    });

    optionNameArr.forEach((name) => {
      let targetObjIndex = optionList.indexOf((obj) => obj.optionName === name);
      optionList.splice(targetObjIndex, 1);
      optionList.unshift({ optionName: name, checked: true });
    });
    optionList.reverse();
    console.log(optionList, optionNameArr);
  }

  updateFilterSlopeNameList(slopeNameArr) {
    let { filter_list } = this.props;
    let listBy = filter_list.find((obj) => obj.title === "listBy");

    if (listBy) {
      // slope name
      listBy.listData[0] = slopeNameArr.map((slopeName) => {
        let isSlopeNameExisted = listBy.listData[0].find(
          (obj) => obj.optionName === slopeName
        );
        if (isSlopeNameExisted) {
          //if current category not changed, current list by not change, will trigger it
          return isSlopeNameExisted;
        } else {
          return { optionName: slopeName, checked: true };
        }
      });
      //location
      listBy.listData[1] = slopeNameArr.map((slopeName) => {
        let isSlopeNameExisted = listBy.listData[1].find(
          (obj) => obj.optionName === slopeName
        );
        if (isSlopeNameExisted) {
          return isSlopeNameExisted;
        } else {
          return { optionName: slopeName, checked: true };
        }
      });
    }
  }

  renderFilterOptions() {
    let {
      filter_list,
      currentCategorySlopeNameskeys,
      currentCategory,
    } = this.props;
    return filter_list.map((filterOption) => (
      <div className="filterOptionBlock">
        <div className="filterOptionTitle">{filterOption.titleText}</div>
        <div className="filterOptionInputs">
          {(() => {
            if (filterOption.type === "Radio") {
              return (
                <RadioGroup
                  row
                  value={this.state.onListOption}
                  onChange={(e) => {
                    this.setState({
                      onListOption: e.target.value,
                    });
                  }}
                >
                  {filterOption.valueText.map((valTxt, idx) => (
                    <FormControlLabel
                      value={filterOption.values[idx]}
                      control={<Radio color="primary" />}
                      label={valTxt}
                    />
                  ))}
                </RadioGroup>
              );
            } else if (filterOption.type === "MultiList") {
              return (
                <React.Fragment>
                  <RadioGroup
                    row
                    value={this.state.activeList}
                    onChange={(e) => {
                      this.setState({
                        activeList: e.target.value,
                      });
                    }}
                  >
                    {[
                      ["slopeNoList", "Slope Number"],
                      ["locationList", "Location"],
                    ].map((val, idx) => (
                      <FormControlLabel
                        value={val[0]}
                        control={
                          <Radio
                            disabled={
                              currentCategory !== GENERAL_RESULT &&
                              this.state.activeList !== val[0]
                            }
                            color="primary"
                          />
                        }
                        label={val[1]}
                      />
                    ))}
                  </RadioGroup>
                  <FilterList listData={this.state[this.state.activeList]} />
                  {/* {filterOption.values.map(
                    (val, idx) => this.state[`show_${filterOption.values[idx]}List`] && 
                        <FilterList listData={filterOption.listData[idx]} />
                  )} */}
                </React.Fragment>
              );
            } else {
              return <div>test</div>;
            }
          })()}
        </div>
      </div>
    ));
  }

  render() {
    let { currentCategorySlopeNameskeys } = this.props;
    // this.props.refreshCurrentSlopeNamesObjectOfCategry(true);
    // this.updateFilterSlopeNameList(currentCategorySlopeNameskeys);
    return (
      <div className="SearchPanelFilterPoupOuterContainer">
        <div className="SearchPanelFilterPopupContainer">
          <div className="ListTitle">Filter</div>
          <div className="resetButton">
            <Button
              variant="outlined"
              onClick={() => {
                this.props.resetFilter({ ...this.state });
              }}
            >
              Reset
            </Button>
          </div>
          <div className="FilterOptionsContainer">
            {this.renderFilterOptions()}
          </div>
          <div className="filterOptionCancelOK">
            <Button color="primary" onClick={this.props.cancelFilterPanel}>
              Cancel
            </Button>
            <Button
              color="primary"
              onClick={() => this.props.okFilterPanel({ ...this.state })}
            >
              OK
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

export default FilterPanel;
